import angular from 'angular';

export default angular.module('unique.id.generator', [])
    .factory('UniqueIdGenerator',  () => {

        let service = {};

        service.generate = (prefix = "section") => {

            let uniqueId = parseInt(Math.random() * 1000000).toString();

            return [prefix, '-', uniqueId].join('');

        };

        return service;

    }).name;





// WEBPACK FOOTER //
// ./src/cmsCore/UniqueIdGenerator/UniqueIdGenerator.js